<template>
  <li
    class="flex items-center text-semantic-inverse-on-surface cursor-pointer"
    :class="{ relative: active }"
    :data-testid="dataTestid"
  >
    <NuxtLink
      :is="to ? 'a' : 'button'"
      :to="to"
      class="focus:outline-none w-full h-full menu-item flex items-center text-sm/[120%] gap-2 px-4 justify-center lg:font-bold"
    >
      <Component
        :is="iconComponent"
        v-if="iconComponent"
        class="w-6 h-6" />

      <slot />

      <V2IconsCaret
        class="w-4 h-4"
        type="thin"
        :fill="semanticColorLookup('inverse.on-surface')"
        :direction="active ? 'top' : 'bottom'"
      />
    </NuxtLink>

    <slot name="after" />
  </li>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsMenuItem'
})

defineProps({
  dataTestid: {
    type: String,
    default: 'atoms-menu-item'
  },

  to: {
    type: String,
    default: null
  },

  iconComponent: {
    type: Object,
    default: null
  },

  active: {
    type: Boolean,
    default: false
  }
})
</script>
